<template>
  <v-container fluid class="pa-8 fill-height">
    <!-- <h1 class="text-center mb-4">Resultados de Exames</h1> -->
    <v-row>
      <v-col cols="4">
        <v-btn x-large elevation="0" class="rounded-lg" block dark color="primary" @click="$router.push({ name: 'login', params: { type: 'paciente' } })">
          <v-icon left>mdi-account</v-icon>
          Paciente
        </v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn x-large elevation="0" class="rounded-lg" block dark color="primary" @click="$router.push({ name: 'login', params: { type: 'medico' } })">
          <v-icon left>mdi-stethoscope</v-icon>
          Médico
        </v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn x-large elevation="0" class="rounded-lg" block dark color="primary" @click="$router.push({ name: 'login', params: { type: 'empresa' } })">
          <v-icon left>mdi-domain</v-icon>
          Empresa
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'Home',

  components: {
  },

  mounted () {
    this.$store.commit('clearCredentials')
  }
}
</script>
